<div class="btn"
  [ngStyle]="{'background-image': 'url(' + img + ')', 'border-radius': br, 'color': disabled ? '#E8E8E8' : ''}"
>
  <ng-content></ng-content>
</div>